<script setup lang="ts">
import AppTable from "@/components/app-table.vue";
import type { ContractDTO } from "@/models/dtos/contract-dto";
import { TableColumn } from "@/models/table-column";
import { contractsService } from "@/services/contracts-service";
import { onBeforeMount, ref, toRefs } from "vue";

const props = defineProps<{
  customerNumber?: string;
  includeUserId?: number;
  excludeUserId?: number;
  disableClick?: boolean;
}>();
const { customerNumber, includeUserId, excludeUserId, disableClick } =
  toRefs(props);

const emit = defineEmits<{
  (e: "click:row", contract: ContractDTO): void;
}>();

const loading = ref(false);

const contractColumns = ref([
  TableColumn.for("eppsusId", "Affärs ID"),
  TableColumn.for("name", "Namn"),
  TableColumn.for("customerNumber", "Kundnummer"),
]);

const contracts = ref<ContractDTO[]>([]);

onBeforeMount(async () => {
  loading.value = true;

  const query: Record<string, unknown> = {};

  if (customerNumber?.value) {
    query.customerNumber = customerNumber.value;
  }

  if (includeUserId?.value) {
    query.includeUserId = includeUserId.value;
  }

  if (excludeUserId?.value) {
    query.excludeUserId = excludeUserId.value;
  }

  contracts.value = await contractsService.getContracts(query);

  loading.value = false;
});

function onClickRow(contract: ContractDTO) {
  emit("click:row", contract);
}
</script>

<template>
  <app-table
    :columns="contractColumns"
    :items="contracts"
    :loading="loading"
    :disable-click="disableClick"
    @click:row="onClickRow"
  ></app-table>
</template>
